angular
	.module 'App.Component'
	.component 'rangeSlider',
		{
			templateUrl: '@component/input/range-slider/range-slider.view.html'
			controller: 'RangeSliderComponent'
			controllerAs: 'slider'
			bindings:
				options: '<?'
				value: '=ngModel'
				disabled: '<?'
				isRequired: '<?'
				min: '@?'
				max: '@?'
				step: '@?'
				symbol: '@?'
				label: '@?'
		}

class RangeSliderComponent extends AbstractController
	@registerController()
	@inject 'parseBool'

	initialize: ->
		@min ?= 0
		@max ?= 100
		@step ?= 1
		@disabled ?= false
		@isRequired ?= false
		@required = @parseBool(@isRequired)

		defaultSliderOptions =
			ceil: @max
			disabled: @disabled
			required: @required
			enforceStep: false
			floor: @min
			hidePointerLabels: true
			keyboardSupport: false
			showSelectionBar: true
			showTicks: true
			step: @step
			ticksArray: @getTicksArray()

		@options = _.extend(defaultSliderOptions, @options)

	getTicksArray: ->
		ticksCount = 5
		tickSize = Math.floor((@max - @min) / (ticksCount - 1))
		ticksArray = []

		for i in [0..ticksCount - 1]
			ticksArray.push({
				value: i * tickSize
			})

		return ticksArray
